import * as React from 'react';
import Button from '@liveauctioneers/caterwaul-components/lib/Button/Button';
import classNames from 'classnames';
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons/faCheckCircle';
import { faExternalLink } from '@fortawesome/pro-regular-svg-icons/faExternalLink';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'react-intl';
import { getCatalogDetail } from '@/redux/modules/catalogDetail';
import { getCatalogRegistration } from '@/redux/modules/catalogRegistration';
import { getItemDetail } from '@/redux/modules/itemDetail';
import isEqual from 'react-fast-compare';
import ShouldLogInContainer from '@/components/ShouldLogIn/ShouldLogInContainer';
import styles from './RequestOnlineBiddingButton.module.scss';
import Text from '@liveauctioneers/caterwaul-components/lib/Text/Text';
import { useSelector } from 'react-redux';

type Props = {
    catalogId: number;
    itemId?: number;
    submitRegisterForCatalog: Function;
    text?: React.ReactNode;
};

const RequestOnlineBiddingButton = (props: Props) => {
    /** Only show the green request_submitted button if approved/pending AND the button has been clicked */
    const [hasClickedButton, setHasClickedButton] = React.useState<boolean>(false);

    const { catalogId, itemId, submitRegisterForCatalog, text = '' } = props;

    const { approved, pending } = useSelector((state) => getCatalogRegistration(state, catalogId), isEqual);
    const { externalUrl: catalogExternalUrl } = useSelector((state) => getCatalogDetail(state, catalogId));
    const { externalUrl: itemExternalUrl } = useSelector((state) => getItemDetail(state, itemId), isEqual);

    const externalUrl = itemId ? itemExternalUrl : catalogExternalUrl;

    return (
        <>
            {(approved || pending) && hasClickedButton ? (
                <Button className={styles.requested} disabled green secondary>
                    <FontAwesomeIcon className={styles.check} icon={faCheckCircle} />
                    <FormattedMessage id="request_submitted" />
                </Button>
            ) : (
                <ShouldLogInContainer
                    requireCompleteProfile
                    requireLogin
                    runFunction={(args) => {
                        setHasClickedButton(true);
                        submitRegisterForCatalog(args);
                        if (Boolean(externalUrl)) {
                            window.open(externalUrl, '_blank');
                        }
                    }}
                    runFunctionArgument={{ catalogId, itemId }}
                >
                    {Boolean(externalUrl) ? (
                        <Button className={classNames(styles.button, styles.externalButton)} primary>
                            {Boolean(text) ? text : <FormattedMessage id="register_partners_site" />}
                            <FontAwesomeIcon className={styles.external} icon={faExternalLink} />
                        </Button>
                    ) : (
                        <Button className={styles.button} primary>
                            {Boolean(text) ? text : <FormattedMessage id="request_online_bidding" />}
                        </Button>
                    )}
                </ShouldLogInContainer>
            )}
            {Boolean(externalUrl) && (
                <Text caption className={styles.warning} colorPrimaryWeak>
                    <FormattedMessage id="register_partners_site_warning" />
                </Text>
            )}
        </>
    );
};

export default React.memo<Props>(RequestOnlineBiddingButton, isEqual);
